'use strict';

import 'angular';

import autocompleteModule from './autocomplete';
import directionsLinkDirective from './directions-link';

const MODULE_NAME = 'brg.maps';

var app = angular.module(MODULE_NAME, [
	autocompleteModule,
]);
app.directive('directionsLink', directionsLinkDirective);

export default MODULE_NAME;
